import React, { useEffect, useState } from 'react';
import { Form, Input, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import qs from 'qs';
// eslint-disable-next-line import/no-extraneous-dependencies
// import { FacebookOutlined, TwitterOutlined } from '@ant-design/icons';
import { AuthWrapper, CASWrapper } from './style';
import { login } from '../../../../redux/authentication/actionCreator';
// import { Checkbox } from '../../../../components/checkbox/checkbox';
import Heading from '../../../../components/heading/heading';
import AuthLayout from '../Index';
import actions from '@redux/authentication/actions';

import HTTPApi from '@services/index'
const { userLogin } = HTTPApi.commom;
const { getUserInfo } = HTTPApi.user;

const SignIn = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.auth.loading);
  const { user } = useSelector(store => {
    return {
      user: store.auth.loginResponse.user || {}
    };
  });
  const [form] = Form.useForm();
  // const [state, setState] = useState({
  //   checked: null,
  // });

  const LoginSuccess = (res) => {
    dispatch(login());
    dispatch(actions.loginResponse(res));
    getUserInfo().then(res => {
      dispatch(actions.loginResponse(res));
    })
  }
  const handleSubmit = () => {
    // 
    form.validateFields().then(values => {
      userLogin(values).then(res => {
        LoginSuccess(res)
      })
    })

  };
  const path = process.env.REACT_APP_CAS_LOGIN_PATH;
  const [CASUrl, setCASUrl] = useState('')
  useEffect(() => {
    const { pathname, search, origin } = window.location;
    let urlSearch = qs.parse(search.slice(1,))
    let params = {
      callbackPath: origin + pathname
    };
    let checkUrlParams = ['step', 'email', 'tk', 'redirect'];
    checkUrlParams.map(type => {
      if (urlSearch[type]) params[type] = urlSearch[type];
    })
    if (user?.email) {
      params.email = user.email
    }
    if (React.i18n.language) {
      params.language = React.i18n.language
    }
    params.service = '1'
    let urlparmas = qs.stringify(params);
    urlparmas && (urlparmas = '?' + urlparmas);
    setCASUrl(path + urlparmas)

    window.addEventListener('message', function (event) {
      if (event.data != undefined && event.data != 'ubaLoadDone') {
        const { status, data, type } = event.data;

        if (status === 'success') {
          if (type === 'login') {
            const lngEnum = {
              1: 'en',
              2: 'zh-CN',
              3: 'zh-HK'
            }
            React.i18n.setLocalLanguage(lngEnum[data.language])
            LoginSuccess(data)
          }
        }
      }
    }, false);
    return () => {
      window.removeEventListener('message', () => { })
    }
  }, [])

  // const onChange = checked => {
  //   setState({ ...state, checked });
  // };
  return (<CASWrapper>
    <iframe src={CASUrl} width={'100%'}></iframe>
  </CASWrapper>)
  return (
    <AuthWrapper>
      {/* <p className="auth-notice">
        Don&rsquo;t have an account? <NavLink to="/register">Sign up now</NavLink>
      </p> */}
      <div className="auth-contents">
        <Form name="login" form={form} onFinish={handleSubmit} layout="vertical">
          <Heading as="h3">
            {/* Sign in to <span className="color-secondary">Admin</span> */}
          </Heading>
          <Form.Item
            name="identifier"
            rules={[{ message: React.t("Page.Login.PleaseInputUsername"), required: true }]}
            initialValue=""
            label={React.t("Page.Login.UsernameOrEmail")}
          >
            <Input />
          </Form.Item>
          <Form.Item name="password" initialValue="" label={React.t("Page.Login.Password")}
            rules={[{ message: React.t("Page.Login.PleaseInputPassword"), required: true }]}

          >
            <Input.Password placeholder="Password" />
          </Form.Item>
          {/* <div className="auth-form-action">
            <Checkbox onChange={onChange}>Keep me logged in</Checkbox>
            <NavLink className="forgot-pass-link" to="/forgotPassword">
              Forgot password?
            </NavLink>
          </div> */}
          <Form.Item>
            <Button className="btn-signin" htmlType="submit" type="primary" size="large">
              {isLoading ? `${React.t("Page.Login.Loading")}...` : React.t("Page.Login.SignIn")}
            </Button>
          </Form.Item>

        </Form>
      </div>
    </AuthWrapper>
  );
};

export default AuthLayout(SignIn);
